export async function getFormUrl(formName: string): Promise<string> {
  if (formName === '联系我们') {
    return 'https://readdy.ai/api/form/d9pi19hn2trhb35gvft0';
  }
  return '';
}